import { Routes } from '@angular/router';
import {CenterViewComponent} from './components/center-view/center-view.component';
import {BlogViewComponent} from './components/blog-view/blog-view.component';
import {FaqViewComponent} from './components/faq-view/faq-view.component';
import {ContactUsComponent} from './components/contact-us/contact-us.component';
import {ReloadComponent} from './components/reload/reload.component';
import {ErrorViewComponent} from './components/error-view/error-view.component';
import {DataDictionaryComponent} from './components/data-dictionary/data-dictionary.component';

export const routes: Routes = [
  {
    path: 'reports',
    component: CenterViewComponent
  },
  {
    path: 'reports/:name',
    component: CenterViewComponent
  },
  {
    path: 'blog/:post-name',
    component: CenterViewComponent
  },
  {
    path: 'blog',
    component: BlogViewComponent
  },
  {
    path: 'faq',
    component: FaqViewComponent
  },
  {
    path: 'data-dictionary',
    component: DataDictionaryComponent
  },
  {
    path: 'contact',
    component: ContactUsComponent
  },
  {
    path: '',
    redirectTo: '/reports',
    pathMatch: 'full'
  },
  {
    path: 'reload',
    component: ReloadComponent
  },
  {
    path: '**',
    component: ErrorViewComponent
  }
];
